import { Skeleton } from "@/components/ui/skeleton";
import Loading from "../common/loading";
import { backofficeLinks } from "@/components/lib/SidebarLinks";

export default function StaffTableSkeleton({ links = backofficeLinks }) {
  return (
    <Loading links={links}>
      <div className="space-y-4 mt-16 px-4">
        {/* Filter Buttons */}
        <div className="flex flex-wrap justify-between gap-4">
          {[...Array(4)].map((_, i) => (
            <Skeleton key={i} className="w-[250px] h-[90px] rounded-xl" />
          ))}
          <Skeleton className="w-[140px] h-[40px] rounded-xl self-start" />
        </div>

        {/* Search Filters & Controls */}
        <div className="flex flex-wrap justify-between gap-4">
          {[...Array(3)].map((_, i) => (
            <Skeleton key={i} className="w-[200px] h-[40px] rounded-md" />
          ))}
          <div className="flex items-center gap-2">
            <Skeleton className="w-[80px] h-[36px] rounded-md" />
            <Skeleton className="w-[40px] h-[36px] rounded-md" />
            <Skeleton className="w-[80px] h-[36px] rounded-md" />
          </div>
        </div>

        {/* Table Header */}
        <Skeleton className="w-full h-10 rounded-md" />

        {/* Table Rows */}
        {[...Array(5)].map((_, i) => (
          <Skeleton key={i} className="w-full h-10 rounded-md" />
        ))}

        {/* Pagination */}
        <div className="flex justify-end">
          <Skeleton className="w-[120px] h-10 rounded-md" />
        </div>
      </div>
    </Loading>
  );
}
